export default "__VITE_PUBLIC_ASSET__45c2ee91__"